import * as Sports from '../../../../constants/SportType';
export var winWithoutDraw = [
    Sports.TABLE_TENNIS,
    Sports.VOLLEYBALL,
    Sports.TENNIS,
    Sports.BASKETBALL,
    Sports.MARTIAL_ARTS,
    Sports.AMERICAN_FOOTBAL,
    Sports.BADMINTON,
    Sports.BASEBALL,
    Sports.SNOOKER,
    Sports.OLYMPIC,
    Sports.BEACH_VOLLEYBALL,
    Sports.WHAT_WHERE_WHEN,
    Sports.CYBER_SPORTS,
    Sports.CYBER_SPORTS_DOTA2,
];



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/matchType.js